import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type JobSubscriptionVariables = Types.Exact<{
  data: Types.JobSubscriptionInput;
}>;


export type JobSubscription = { job: { id: string, status: Types.JobEntityStatusEnum } };


export const JobDocument = /*#__PURE__*/ gql`
    subscription Job($data: JobSubscriptionInput!) {
  job(data: $data) {
    id
    status
  }
}
    `;

export function useJobSubscription<TData = JobSubscription>(options: Omit<Urql.UseSubscriptionArgs<JobSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<JobSubscription, TData>) {
  return Urql.useSubscription<JobSubscription, TData, JobSubscriptionVariables>({ query: JobDocument, ...options }, handler);
};